import { render, staticRenderFns } from "./customer-modal-selector.vue?vue&type=template&id=5f2ce5a6&"
import script from "./customer-modal-selector.vue.ts?vue&type=script&lang=ts&"
export * from "./customer-modal-selector.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports